module.exports = __webpack_public_path__ + "static/tpf-6f0688f2c902ffd8f498b63d24b91dca.svg";